// extracted by mini-css-extract-plugin
export default {"contentTopPadding":"pageLayout_contentTopPadding__-oS0t","titleBlockMargin":"pageLayout_titleBlockMargin__iRlDq","pageHeaderArea":"pageLayout_pageHeaderArea__N38Wa"};